<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.00033 0.666748H10.0003C10.7367 0.666748 11.3337 1.2637 11.3337 2.00008V10.0001C11.3337 10.7365 10.7367 11.3334 10.0003 11.3334H2.00033C1.26395 11.3334 0.666992 10.7365 0.666992 10.0001V2.00008C0.666992 1.2637 1.26395 0.666748 2.00033 0.666748ZM6.00032 2.6667C5.63213 2.6667 5.33365 2.96518 5.33365 3.33337C5.33365 3.70156 5.63213 4.00004 6.00032 4.00004H6.00565C6.37384 4.00004 6.67232 3.70156 6.67232 3.33337C6.67232 2.96518 6.37384 2.6667 6.00565 2.6667H6.00032ZM5.33366 5.33339C4.96547 5.33339 4.66699 5.63187 4.66699 6.00006C4.66699 6.36825 4.96547 6.66673 5.33366 6.66673V8.66673C5.33366 9.03491 5.63213 9.33339 6.00032 9.33339H6.66699C7.03518 9.33339 7.33366 9.03491 7.33366 8.66673C7.33366 8.29854 7.03518 8.00006 6.66699 8.00006L6.66699 6.00006C6.66699 5.63187 6.36851 5.33339 6.00032 5.33339H5.33366Z"
            fill="#6F7287"
        />
    </g>
</template>
<script>
export default {
    name: "InfoSquare",
};
</script>
